import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	flex-direction: column;
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 12px;
	font-size: 16px;
	text-decoration: underline;
	text-underline-offset: 2px;
	text-decoration-thickness: 0.5px;
	font-weight: 200;
	opacity: 0.7;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 1;
	}
`;
